import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import MenuBar from '../../components/menuBar/menuBar';
import PageFooter from '../../components/pageFooter/pageFooter';
import AboutUsHero from '../../components/aboutUsComponents/AboutUsHero/AboutUsHero';
import AboutUsMission from '../../components/aboutUsComponents/AboutUsMission/AboutUsMission';
import AboutUsValues from '../../components/aboutUsComponents/AboutUsValues/AboutUsValues';
import AboutUsTeam from '../../components/aboutUsComponents/AboutUsTeam/AboutUsTeam';
import AboutUsStory from '../../components/aboutUsComponents/AboutUsStory/AboutUsStory';

const AboutUsPage = () => {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>About Us | Prepal - AI-Powered Test Preparation</title>
                <meta name="description" content="Learn about Prepal's mission to revolutionize test preparation through AI-powered personalized learning. Discover our story, values, and the team behind your success." />
                <meta name="keywords" content="Prepal about us, test prep company, AI education, personalized learning, Prepal team, educational technology" />
                <meta name="author" content="Prepal Team" />
            </Helmet>

            <MenuBar />

            {/* Hero */}
            <AboutUsHero />

            {/* Who's Behind Prepal */}
            <AboutUsMission />

            {/* The Founder's Story */}
            <AboutUsStory />

            {/* Backed by AdvantagePrep Network */}
            <AboutUsValues />

            {/* Roadmap */}
            <AboutUsTeam />

            <PageFooter />
        </>
    );
};

export default AboutUsPage;
